import api from '@/services/api';
import { make } from 'vuex-pathify';
const state = {
  history: [],
};
const mutations = {
  ...make.mutations(state),
};
const actions = {
  async getHistory({ commit }, payload) {
    const { data_source_name, feature_id } = payload;
    const r = await api.get(`/history/${data_source_name}/${feature_id}`);
    commit('SET_HISTORY', r.data.data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
